import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '@/components/ConfirmationModal';
import { showError } from '@/utils';
import { cancelSubscription } from '@/store/billing/thunks';

export function CancelSubscriptionModal({ onClose, ...props }) {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	const handleConfirm = async () => {
		try {
			setLoading(true);

			await dispatch(cancelSubscription()).unwrap();

			onClose();
		} catch (err) {
			showError(err);
		}
		setLoading(false);
	};

	return (
		<ConfirmationModal
			loading={loading}
			text={t('billing.subscription.cancelConfirmation')}
			closeText={t('common.close')}
			confirmText={t('billing.yesCancel')}
			onConfirm={handleConfirm}
			onClose={onClose}
			{...props}
		/>
	);
}
